import mitekUtil from './mitekUtil';
import 'vendor/nocompile/MitekMobileWeb.worker.js';

export default mitekUtil;
